<ng-container *transloco="let t">
    <div class="camera-purpose flex flex-col items-center text-center gap-2 py-4">
        <mat-icon class="icon-size-10">{{ purpose === 'CODE' ? 'qr_code_scanner' : 'photo_camera' }}</mat-icon>
        <h3 class="font-semibold">{{ t('CAMERA-PURPOSE-TITLE') }}</h3>
        <p>{{ purpose === 'CODE' ? t('CAMERA-PURPOSE-CODE') : t('CAMERA-PURPOSE-PHOTO') }}</p>
        <p class="text-sm text-secondary">{{ t('CAMERA-PURPOSE-HINT') }}</p>
        <button mat-flat-button color="primary" type="button" class="mt-2" (click)="start.emit()">
            {{ t('CAMERA-PURPOSE-START') }}
        </button>
    </div>
</ng-container>
